export const newGamesList = [
  'Aviamasters',
  // 'вставлять сверху',
  'vswaysincwnd',
  'vswaystut',
  'vswaysstrlght',
  '31882',
  '31874',
  '31878',
  '31895',
  '31843',
  '31879',
  '49929',
  '36273',
  '31865',
  '31895',
  '31872',
  '31840',
  '35780',
  '31836',
  '31839',
  '31842',
  '31844',
  '31873',
  '31846',
  '31860',
  'vs10gdchalleng',
  'vs20wildparty',
  'vs20lobcrab',
  'vs243nudge4gold',
  'vswayspowzeus',
  'vs20cashmachine',
  'vs20procount',
  'vs20splmystery',
  'vs20hstgldngt',
  'vs10bbextreme',
  'vs20beefed',
  'vs10fdrasbf',
  'lagranaventura_original',
  'luckyzodiac_original',
  'oktoberfest_original',
  'megashark_original',
  'vampires_original',
  'grandtiger_original',
  'dragonsmystery_original',
  'goldenquest_original',
  'buffalothunderstacks_original',
  'dragonsgift_original',
  'hotchoicedeluxe_original',
  'hot81_original',
  'bookoffruits20_original',
  'bookoffruitshalloween_original',
  'allwayshotfruits_original',
  'pragmaticexternal:StickyBees',
  'pragmaticexternal:ZeusvsHadesGodsofWar',
  'pragmaticexternal:PiratesPub',
  'pragmaticexternal:JewelRush',
  'pragmaticexternal:LampOfInfinity',
  'pragmaticexternal:DiamondsOfEgypt',
  'pragmaticexternal:KnightHotSpotz',
  'pragmaticexternal:WildBisonCharge',
  'pragmaticexternal:ExcaliburUnleashed',
  'pragmaticexternal:KingdomofTheDead',
  'pragmaticexternal:JaneHunterandtheMaskofMontezuma',
  'pragmaticexternal:WildCelebrityBusMegaways',
]
